/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import Slider from "react-slick";
// import CarImage from "./images/car-image.png";
import { GALLERY_TAB_TYPE } from "../car-detail-info/constant";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { getCDPAltText } from "../../../utils/helpers/get-cdp-alt-text";
import { NUMBER } from "../../../constants/app-constants";
import Three60 from "./images/three-sixty.png";
import Three60Active from "./images/three-sixty-active.png";
// import VehicleInfoSection from "./vehicle-info-section";
// import LockIcon from "./images/lock.svg";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import CarUspContainer from "../car-usp-container";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";
import getCarInfo from "../../../utils/helpers/get-car-info";
const navigationElements = {
    tour: {
        key: GALLERY_TAB_TYPE.threeSixtyView,
        img: Three60,
        imgActive: Three60Active,
        label: "Tour",
        gaEvent: "360View"
    },
    exterior: {
        key: GALLERY_TAB_TYPE.exterior,
        img: null,
        label: "Exterior",
        gaEvent: "exterior"
    },
    interior: {
        key: GALLERY_TAB_TYPE.interior,
        img: null,
        label: "Interior",
        gaEvent: "interior"
    },
    noDefects: {
        key: GALLERY_TAB_TYPE.imperfections,
        img: null,
        label: "No Imperfections",
        gaEvent: "imperfections"
    },
    defects: {
        key: GALLERY_TAB_TYPE.imperfections,
        img: null,
        label: "Imperfections",
        gaEvent: "imperfections"
    },
    highlights: {
        key: GALLERY_TAB_TYPE.highlights,
        img: null,
        label: "Highlights",
        gaEvent: "highlights"
    },
    allImages: {
        key: GALLERY_TAB_TYPE.allImages,
        img: null,
        label: "All Images",
        gaEvent: "allImages"
    }
};

const HeroSliderCdpRevamp = ({
    content,
    openGalleryPopUp,
    imageHost,
    desktopPremiumFeatures,
    brandImageHost,
    hideImperfectionsDesktop

}) => {
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const { isDealerListing, isInternalListing } = getCarInfo(content);
    const { imperfectionImages, exteriorImages, interiorImages, threeSixtyViewUrl, make, model, year, variant, transmissionType, odometerReading, threeSixtyViewAvailable, highlightsGallery = [], mainImage, galleryV2 } = content || {};
    const desktopPremiumFeaturesVariant = getAbExpirementVariant(desktopPremiumFeatures, EXPERIMENT_TYPE.VARIANT_B, GALLERY_TAB_TYPE.allImages);
    const hideImperfections = getAbExpirementVariant(hideImperfectionsDesktop, EXPERIMENT_TYPE.VARIANT_B);
    const exteriorImgGallery = (exteriorImages || []).map((image, index) => ({ ...image, tabName: "Exterior", key: desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.exterior, imageIndex: index }));
    const interiorImgGallery = (interiorImages || []).map((image, index) => ({ ...image, tabName: "Interior", key: desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.interior, imageIndex: index }));
    const defectImgGallery = (imperfectionImages || []).map((image, index) => ({ ...image, tabName: "Imperfections", key: GALLERY_TAB_TYPE.imperfections, imageIndex: index }));
    const highlightsImgGallery = (highlightsGallery || []).map((image, index) => ({ ...image, tabName: "Highlights", key: GALLERY_TAB_TYPE.highlights, imageIndex: index }));
    // Only include highlights in gallery if the highlights tab is visible
    const showHighlights = desktopPremiumFeaturesVariant || (hideImperfections && !threeSixtyViewAvailable);
    const gallery = isDealerListing ? [...galleryV2] : [...exteriorImgGallery, ...interiorImgGallery, ...(showHighlights ? highlightsImgGallery : []), ...defectImgGallery];
    const [activeTab, setActiveTab] = useState(desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : navigationElements.exterior.key);
    const [activeIndex, setActiveIndex] = useState(NUMBER.ZERO);
    const handleTab = (tabName = "") => {
        // if (desktopPremiumFeaturesVariant && (tabName === GALLERY_TAB_TYPE.exterior || tabName === GALLERY_TAB_TYPE.interior)) {
        //     setActiveTab(GALLERY_TAB_TYPE.allImages);
        // }
        setActiveTab(tabName);
    };
    const settingsSlider1 = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: (index) => {
            handleTab(gallery[Math.floor(index)]?.key, 0);
            setActiveIndex(index);
        },

        // eslint-disable-next-line no-shadow
        ref: slider1 => setNav1(slider1),
        asNavFor: nav2,
        lazyLoad: "ondemand"
    };

    const altTextDetails = {
        year,
        make,
        model,
        variant,
        transmissionType,
        odometerReading
    };

    /**
     *
     * @param {*} index
     * @param {*} tabName
     * @returns {boolean}
     * @description
     * This function is used to get the image category by index and tab name.
     * If tabName is provided, it will return true if the image category is the same as the tabName, otherwise it will return the image category.
     * If tabName is not provided, it will return the image category.
     *
     * @example
     * getImageCategoryByIndex(0, GALLERY_TAB_TYPE.exterior); // returns true
     */

    const getImageCategoryByIndex = (index, tabName) => {
        let exteriorImagesLength;
        let interiorImagesLength;
        let highlightsImagesLength;
        let imperfectionImagesLength;
        if (isDealerListing) {
            exteriorImagesLength = galleryV2?.length;
        } else {
            exteriorImagesLength = exteriorImages.length;
            interiorImagesLength = interiorImages.length;
            highlightsImagesLength = highlightsGallery.length;
            imperfectionImagesLength = imperfectionImages.length;
        }
        let type;

        if (index < exteriorImagesLength) {
            type = GALLERY_TAB_TYPE.exterior;
        } else if (index < exteriorImagesLength + interiorImagesLength) {
            type = GALLERY_TAB_TYPE.interior;
        } else if (index < exteriorImagesLength + interiorImagesLength + highlightsImagesLength) {
            type = GALLERY_TAB_TYPE.highlights;
        } else if (index < exteriorImagesLength + interiorImagesLength + highlightsImagesLength + imperfectionImagesLength) {
            type = GALLERY_TAB_TYPE.imperfections;
        }

        if (tabName) {
            return tabName === type;
        }
        return type;
    };

    const handleHelloArTabClick = (tabName, index) => {
        const imageCategory = getImageCategoryByIndex(index);
        if (imageCategory) {
            openGalleryPopUp(imageCategory, index, imageCategory);
        } else {
            openGalleryPopUp(threeSixtyViewUrl ? GALLERY_TAB_TYPE.threeSixtyView : GALLERY_TAB_TYPE.exterior, 0);
        }
    };
    const openThreeSixtyView = (index) => {
        handleHelloArTabClick(activeTab, index);
    };

    let carImperfectionsCount = 0;
    if (gallery) {
        gallery.forEach(element => {
            if (element?.tabName?.toLowerCase() === navigationElements.defects.key.toLowerCase()) carImperfectionsCount += NUMBER.ONE;
        });
    }
    const navigationTabs = {
        [navigationElements.tour.key]: {
            ...navigationElements.tour,
            show: threeSixtyViewAvailable
        },
        [navigationElements.exterior.key]: {
            ...navigationElements.exterior,
            show: !desktopPremiumFeaturesVariant
        },
        [navigationElements.interior.key]: {
            ...navigationElements.interior,
            show: !desktopPremiumFeaturesVariant
        },
        [navigationElements.allImages.key]: {
            ...navigationElements.allImages,
            show: desktopPremiumFeaturesVariant
        },
        [navigationElements.highlights.key]: {
            ...navigationElements.highlights,
            show: desktopPremiumFeaturesVariant || (hideImperfections && !threeSixtyViewAvailable)
        },
        [navigationElements.defects.key]: {
            ...navigationElements.defects,
            show: !hideImperfections,
            carDefectCounterText: carImperfectionsCount > NUMBER.ZERO ? `Imperfections (${carImperfectionsCount})` : "No Imperfections"
        }
    };

    const updateActiveTab = (tabName) => {
        handleTab(tabName);
        // if (mediaSource === MEDIA_SOURCE.s20) {
        //     handleTabClick(tabName);
        // } else {
        //     handleHelloArTabClick(tabName);
        // }
        // if tabName is exterior, scroll the slider to the first image
        if (tabName === GALLERY_TAB_TYPE.exterior) {
            nav1.slickGoTo(0);
        }
        if (tabName === GALLERY_TAB_TYPE.interior) {
            nav1.slickGoTo(exteriorImgGallery.length);
        }
        if (tabName === GALLERY_TAB_TYPE.highlights) {
            nav1.slickGoTo(exteriorImgGallery.length + interiorImgGallery.length);
        }
        if (tabName === GALLERY_TAB_TYPE.allImages) {
            nav1.slickGoTo(0);
        }
        if (tabName === GALLERY_TAB_TYPE.imperfections) {
            if (carImperfectionsCount === NUMBER.ZERO) {
                handleHelloArTabClick(tabName, 0, GALLERY_TAB_TYPE.imperfections);
                return;
            }
            nav1.slickGoTo(exteriorImgGallery.length + interiorImgGallery.length + highlightsImgGallery.length);
        }
        if (tabName === GALLERY_TAB_TYPE.threeSixtyView) {
            handleHelloArTabClick(tabName);
        }
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.CDP_TAB_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.CDP_TAB_SELECTED,
            eventLabel: content.appointmentId,
            eventAction: tabName
        });

    };
    const onSliderScroll = () => { };

    const settingsSlider2 = {
        asNavFor: nav1,
        // eslint-disable-next-line no-shadow
        ref: slider2 => setNav2(slider2),
        swipeToSlide: true,
        focusOnSelect: true,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        infinite: false,
        arrow: false,
        dots: false,
        afterChange: onSliderScroll
    };
    return (
        <div>
            <div styleName={"styles.topSliderWrapper"}>
                <Slider {...settingsSlider1}>
                    {(gallery || []).map((image, index) => {
                        return (
                            <div styleName="styles.premiumItemsWrap">
                                <img
                                    key={index}
                                    src={fastlyUrl(imageHost, image?.path || mainImage?.path, imageTypes.carDetailHeroImage)}
                                    alt={`${getCDPAltText(altTextDetails)}, ${image?.label || ""}`}
                                    onClick={() => openThreeSixtyView(index)}
                                />
                                {image?.items && <CarUspContainer slideData={gallery[activeIndex]} />}
                            </div>
                        );
                    })}

                </Slider>

                {isInternalListing && <div styleName={"styles.topTabWrapper"}>
                    {Object.values(navigationTabs).map((tab) => {
                        if (!tab.show) {
                            return null;
                        }
                        return (
                            <p key={tab.key} styleName={`styles.tabName ${activeTab === tab.key ? "styles.active" : ""} ${tab.key === GALLERY_TAB_TYPE.threeSixtyView && threeSixtyViewAvailable ? " styles.threeSixtyTabNew" : ""}`} onClick={() => updateActiveTab(tab.key)}>
                                {tab ? tab.img && <img src={activeTab === tab.key ? tab.imgActive : tab.img} alt="" /> : ""}
                                {tab.key === navigationElements.defects.key ? tab?.carDefectCounterText && <span>{tab?.carDefectCounterText}</span> : tab.label}
                            </p>
                        );
                    })}
                </div>}
            </div>

            <div styleName="styles.sliderWrapper">
                <Slider {...settingsSlider2}>
                    {(gallery || []).map(((item = {}, index) => {
                        return (<div key={item?.path} styleName="styles.slider2ImageWrapper">
                            <img
                                src={fastlyUrl(imageHost, item?.path || mainImage?.path, imageTypes.spinCarZoomable)}
                                alt={`${getCDPAltText(altTextDetails)}, ${item?.label || ""}`}
                            />
                            {<div styleName={`${item.key === GALLERY_TAB_TYPE.highlights ? "styles.sliderOverlay" : ""} ${activeIndex === index ? "styles.slider2ActiveState" : ""}`} />}
                            {item.key === GALLERY_TAB_TYPE.highlights && <img src={fastlyUrl(brandImageHost, item.overlayImage)} styleName="styles.sliderOverlayIcon" alt={item?.label || "Highlight"} />}
                        </div>);
                    }

                    ))}
                </Slider>
            </div>
        </div>
    );
};
HeroSliderCdpRevamp.propTypes = {
    content: PropTypes.object,
    openGalleryPopUp: PropTypes.func,
    imageHost: PropTypes.string,
    isUserZeroDpVariant: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    reserved: PropTypes.bool,
    match: PropTypes.number,
    desktopPremiumFeatures: PropTypes.object,
    fomoData: PropTypes.object,
    setFomoNudgeDataConnect: PropTypes.func,
    fomoText: PropTypes.object,
    isStickyHeaderVisible: PropTypes.bool,
    desktopWishlistAdoption: PropTypes.object,
    carSeenCount: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    brandImageHost: PropTypes.string,
    hideImperfectionsDesktop: PropTypes.object
};

export default HeroSliderCdpRevamp;
